export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20dark%20gradient%20background%20with%20warm%20crimson%20and%20deep%20amber%20tones%2C%20soft%20bokeh%20light%20particles%2C%20movie%20theater%20atmosphere%2C%20elegant%20subtle%20texture%2C%20no%20text%2C%20no%20faces%2C%20moody%20cinematic%20lighting%2C%20professional%20film%20aesthetic%2C%20smooth%20gradients%2C%20atmospheric%20depth&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="私密视频平台背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs text-background-50/90 whitespace-nowrap">
                红桃视频 · 西瓜视频 · 小蓝视频
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
              私密视频
              <span className="block text-xl md:text-2xl lg:text-3xl font-normal text-background-50/80 mt-2">
                综合高清视频平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-background-50/70 font-light mb-4">
              免费在线观看，高清不缓冲
            </p>

            <p className="text-sm md:text-base text-background-50/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              私密视频汇聚红桃视频、西瓜视频免费、小蓝视频、茄子视频、久久视频、芒果视频等优质资源，
              致力于打造一站式综合视频服务平台。无论热门大片还是冷门佳作，高清画质流畅播放，
              无需缓冲等待，随时随地畅享精彩视听体验。每日更新海量内容，覆盖影视剧集、
              综艺动漫、纪录片等全品类，让每一次观影都成为享受。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {[
                { icon: 'ri-movie-2-line', label: '10万+部影片资源', sub: '持续更新' },
                { icon: 'ri-shield-check-line', label: '高清流畅不缓冲', sub: '稳定播放' },
                { icon: 'ri-user-heart-line', label: '500万+活跃用户', sub: '口碑见证' },
              ].map((stat) => (
                <div key={stat.label} className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-background-50/10 flex items-center justify-center">
                    <i className={`${stat.icon} text-lg text-accent-400`}></i>
                  </div>
                  <div className="text-left">
                    <div className="text-sm font-medium text-background-50 whitespace-nowrap">{stat.label}</div>
                    <div className="text-xs text-background-50/50">{stat.sub}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即探索热门专题
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-50/10 text-background-50 border border-background-50/25 rounded-full font-medium text-sm hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20movie%20poster%20collage%20with%20warm%20crimson%20gold%20tones%2C%20abstract%20film%20reel%20and%20play%20button%20elements%2C%20cinematic%20composition%2C%20dramatic%20lighting%2C%20elegant%20dark%20background%2C%20modern%20streaming%20platform%20aesthetic%2C%20rich%20textures%2C%20professional%20design%2C%20entertainment%20theme&width=900&height=1125&seq=hero-poster-2026&orientation=portrait"
                alt="私密视频影视合集"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center cursor-pointer">
                    <i className="ri-play-fill text-xl text-background-50"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-background-50">今日推荐合集</p>
                    <p className="text-xs text-background-50/60">精选热门影片 · 高清画质</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}